<template>
  <div>
    <div class="display-flex w-100 justify-content-between">
      <h2 class="mb-0">Karnety</h2>
      <TicketChips :searched="Object.assign({}, searched)"
                    @updateData="changeSearchData"
                    @toggleSearch="setToggle">
      </TicketChips>
    </div>
    <transition name="fade" mode="out-in">
      <div class="display-flex w-100 justify-content-end search-form" v-if="searchTickets">
        <TicketSearch :propsSearchData="searchData"
                       :userList="getUsersList"
                       @search="search"></TicketSearch>
      </div>
    </transition>
    <div class="mt-4 content-wrapper p-3">
      <TicketTable :loading="loading"
                    :totalItems="getTotalTickets"
                    :currentPage="tablePage"
                    @paginationChange="onPaginationChange"
                    @printPDF="printPDF"
                    @exportPDF="exportPDF"
                    @deleteTicket="prepareToOpenModal"
                    @finishTicket="prepareToOpenModal"/>
    </div>
    <div class="display-flex justify-content-end mt-2">
      <v-btn class="mr-0"
             :loading="exportLoading"
             @click="exportExcel">
        Eksportuj
      </v-btn>
    </div>
    <DeleteModal
      :open="deleteTicket"
      deleteText="Czy na pewno chcesz usunąć ticket?"
      @close="deleteTicket = false"
      @accept="removeTicket({id:ticketIdToEdit, searchObj}); deleteTicket = false"
    ></DeleteModal>
    <DeleteModal
      :open="deactivateTicket"
      :show-textarea="showTextarea"
      deleteText="Czy na pewno chcesz zakończyć ticket?"
      @close="deactivateTicket = false"
      @accept="disableTicket"
    ></DeleteModal>
    <router-view></router-view>
  </div>
</template>

<script>
  /* eslint-disable no-unused-expressions */

  import {mapGetters, mapActions} from 'vuex';
  import FileSaver from 'file-saver';
  import printJS from 'print-js';
  import DeleteModal from '../components/Globals/ModalDelete.vue';
  import TicketChips from '@/components/Tickets/TicketChips.vue';
  import TicketSearch from '@/components/Tickets/TicketsSearch.vue';
  import TicketTable from '@/components/Tickets/TicketTable.vue';
  import {clearEmptyFields} from '../helpers/clearEmptyFields';
  import {getPDF} from '../services/api.service';

  export default {
    name: 'Tickets',
    components: {
      DeleteModal,
      TicketChips,
      TicketSearch,
      TicketTable,
    },
    data() {
      return {
        showTextarea: false,
        searchObj: {},
        searchTickets: false,
        deleteText: null,
        ticketIdToEdit: null,
        loading: true,
        exportLoading: false,
        tablePage: 1,
        lastPagination: null,
        finishTicketDate: new Date().toISOString()
          .substr(0, 10),
        finishTicketDatePicker: false,
        deleteTicket: false,
        deactivateTicket: false,
        searchData: {},
        searched: {},
      };
    },
    computed: {
      ...mapGetters('UserStore', ['getUsersList']),
      ...mapGetters('TicketStore', ['getTotalTickets']),
    },
    watch: {
      $route(from) {
        from.name === 'Tickets' ? this.fetchTickets(this.buildFetchParams(this.searchObj, this.lastPagination)) : null;
      },
    },
    beforeMount() {
      this.fetchTickets(this.buildFetchParams({}, null))
        .then(() => {
          this.loading = false;
        });
      if (JSON.parse(localStorage.getItem('USERDATA')).type !== 'U') {
        this.fetchUsers();
      }
    },
    methods: {
      ...mapActions('TicketStore', ['fetchTickets', 'removeTicket', 'turnOffTicket', 'getPDF', 'downloadPDF', 'fetchTicketsExcel']),
      ...mapActions('UserStore', ['fetchUsers']),
      async printPDF(id) {
        const response = await getPDF(`/ticket/pdf/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        printJS(URL.createObjectURL(blob));
      },
      prepareToOpenModal(id, key, showTextarea) {
        this[key] = true;
        this.ticketIdToEdit = id;
        this.showTextarea = showTextarea;
      },
      setToggle(toggle) {
        this.searchTickets = toggle;
      },
      async exportPDF(id, number, type) {
        const response = await getPDF(`/ticket/pdf/realization/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        FileSaver.saveAs(blob, `${number} - ${type} - ${this.moment(new Date())
          .format('DD-MM-YYYY')} - export`);
      },
      async exportExcel() {
        this.exportLoading = true;
        try {
          const response = await this.fetchTicketsExcel(this.searchObj);
          const blob = new Blob([response.data], {
            type: 'application/vnd.ms-excel',
          });
          FileSaver.saveAs(blob, `TicketsExport - ${this.moment(new Date())
            .format('DD-MM-YYYY')} - export`);
        } catch (e) {
          console.log(e);
        } finally {
          this.exportLoading = false;
        }
      },
      buildFetchParams(searchObj, pagination) {
        const params = Object.assign({}, searchObj);
        params.page = (pagination && pagination.page) || 1;
        params.per_page = (pagination && pagination.rowsPerPage) || 10;
        if (pagination && pagination.sortBy) {
          params.sort_by = pagination.sortBy;
          params.sort_dir = pagination.descending ? 'desc' : 'asc';
        }
        return params;
      },
      onPaginationChange(pagination) {
        this.lastPagination = pagination;
        this.fetchTickets(this.buildFetchParams(this.searchObj, pagination));
      },
      search(prepare, data) {
        if (data !== undefined) this.searchData = data;
        if (prepare) this.prepareChips();
        const searchObj = clearEmptyFields(Object.assign({}, this.searchData));
        if (searchObj.user_id) {
          searchObj.user_id = searchObj.user_id.id;
        }

        this.searchObj = searchObj;
        this.tablePage = 1;
        this.lastPagination = null;
        this.fetchTickets(this.buildFetchParams(searchObj, null));
      },
      changeSearchData(element) {
        this.searched[element] = null;
        this.searchData[element] = null;
        if (element === 'created') {
          this.searchData.created_from = null;
          this.searchData.created_to = null;
        }
        if (element === 'expiration_date') {
          this.searchData.expiration_date_from = null;
          this.searchData.expiration_date_to = null;
        }

        this.search(false);
      },
      prepareChips() {
        this.searched = Object.assign({}, this.searchData);
        this.searched.created = this.formatDate('created_from', 'created_to', this.searchData);
        this.searched.expiration_date = this.formatDate('expiration_date_from', 'expiration_date_to', this.searchData);
      },
      formatDate(createdOrExpiredAtKey, createdOrExpiredDueKey, input) {
        const searchData = Object.assign({}, input);
        if (searchData[createdOrExpiredAtKey] && searchData[createdOrExpiredDueKey]) {
          return `${searchData[createdOrExpiredAtKey].toString()} — ${searchData[createdOrExpiredDueKey].toString()}`;
        }
        if (searchData[createdOrExpiredAtKey]) {
          return searchData[createdOrExpiredAtKey].toString();
        }
        if (searchData[createdOrExpiredDueKey]) {
          return searchData[createdOrExpiredDueKey].toString();
        }
        return null;
      },
      disableTicket(formData) {
        this.deactivateTicket = false;
        this.showTextarea = false;
        this.turnOffTicket({
          id: this.ticketIdToEdit,
          formData,
        })
          .then(() => {
            this.fetchTickets(this.buildFetchParams(this.searchObj, this.lastPagination));
          });
      },
    },
  };
</script>
